const LocaleStorageKey = {
  FavoritesTokens: 'favoritesTokens',
} as const

type LocaleStorageKey = typeof LocaleStorageKey[keyof typeof LocaleStorageKey]

export default LocaleStorageKey;
